// extracted by mini-css-extract-plugin
export var main = "surgeryTypeText-module--main--0tySV";
export var opened = "surgeryTypeText-module--opened--m67Vi";